import { Pipe, PipeTransform } from "@angular/core";
import { Web3Service } from "app/services/web3/web3.service";

@Pipe({
    name: 'fromWei',
    pure: false
})
export class FromWeiPipe implements PipeTransform {

    constructor(
        private web3Service: Web3Service
    ) { }


    transform(value: string, args: any[]): string {
        return this.web3Service.fromWeiFloat(value) + '';
    }

}